import { isEmptyArray } from "@tradingApp/utils/array/isEmptyArray";

/**
 * Add support for additional attributes in markdown links.
 *
 * @example
 * const link = "https://github.com|rel=noopener,nofollow|target=_blank"
 * markdownRendererLink(link, "Some title", "Link anchor text");
 * // <a href="https://github.com" rel="noopener nofollow" target="_blank">GitHub</a>
 */
export function markdownRendererLink(
  rawHref: string,
  title: string | null | undefined,
  text: string,
): string {
  const [href, ...rawAttributes] = rawHref.split("|");

  const additionalAttributes = !isEmptyArray(rawAttributes)
    ? getAdditionalAttributes(rawAttributes)
    : null;

  const attributes = getAllAttributes({
    title,
    ...additionalAttributes,
  });

  return `<a href="${href}" ${attributes.join(" ")}>${text}</a>`;
}

function getAdditionalAttributes(
  rawAttributes: string[],
): Record<string, string> {
  const result = {};

  const filteredAttributes = rawAttributes.filter((attribute) => {
    return attribute.includes("=");
  });

  for (const rawAttribute of filteredAttributes) {
    const [key, value] = rawAttribute.split("=");
    const hasMultipleValues = typeof value === "string" && value.includes(",");

    if (hasMultipleValues) {
      // @ts-expect-error
      result[key] = value.split(",").join(" ");
    } else {
      // @ts-expect-error
      result[key] = value;
    }
  }

  return result;
}

function getAllAttributes(
  rawAttributes: Record<string, string | null | undefined>,
): string[] {
  const entries = Object.entries(rawAttributes);
  const result = [];

  for (const [key, value] of entries) {
    if (value) {
      result.push(`${key}="${value}"`);
    }
  }

  return result;
}
